<template>
  <Modal :closable="false">
    <div class="modal__shields">
      <ModalShield
        v-for="level in levels.length - 1"
        :key="level"
        :icon="
          levels[level].state === 'finish' ? 'prizeUnlocked' : 'prizeLocked'
        "
        :class="{ 'shield--active': levels[level].state === 'finish' }"
      />
      <ModalShield
        :icon="secretFound ? 'prizeUnlocked' : 'prizeLocked'"
        :class="['shield--secret', { 'shield--active': secretFound }]"
      />
    </div>

    <template v-if="levelId === 1">
      <h1>Вы победили Алланта!</h1>
      <p v-if="!secretFound">Король повержен, но это далеко не конец…</p>
      <p v-else>Король повержен всего за 10 ходов, за этот подвиг вы получите награду в конце игры. Но дойдете ли вы до конца?</p>
      <div class="modal__actions">
        <button class="button" @click="nextLevel" :data-pixel="pixels.next">
          Следующее задание
        </button>
      </div>

      <img src="../assets/img/divider.svg" class="modal__divider" />
      <div class="modal__info">
        <p>А вы знали, что <span v-html="getRandomFact()" /></p>
      </div>
    </template>

    <template v-if="levelId === 2">
      <h1>Элли спасена!</h1>
      <p>
        Вы покрошили этого кликера, Элли в безопасности. Впереди еще одно
        поручение.
      </p>
      <div class="modal__actions">
        <button class="button" @click="nextLevel" :data-pixel="pixels.next">
          Следующее задание
        </button>
      </div>

      <img src="../assets/img/divider.svg" class="modal__divider" />
      <div class="modal__info">
        <p>А вы знали, что <span v-html="getRandomFact()" /></p>
      </div>
    </template>

    <template v-if="levelId === 3 && !secretFound">
      <h1>Вы прошли игру!</h1>
      <p>
        Однако, осталось одно незаконченное дело. Секретный трофей вы так и не
        получили, а без него не видать награды в профиле на Пикабу.
      </p>
      <img src="../assets/img/divider.svg" class="modal__divider" />
      <p>
        Тем не менее, чтобы по-настоящему погрузиться в мир PlayStation 5,
        секретный трофей вам не нужен. Подробнее о консолях PS5 вы можете узнать
        <a :href="links.store | randomizeLink">в фирменном интернет-магазине</a
        >.
      </p>
      <div class="modal__actions">
        <a class="button" :href="links.preorder | randomizeLink" target="_blank"
          >Подробнее о PS5</a
        >
        <button
          class="button button--secondary"
          @click="restart"
          :data-pixel="pixels.restart"
        >
          Начать заново
        </button>
      </div>
      <img src="../assets/img/divider.svg" class="modal__divider" />
      <div class="finish-sharer">
        <SharerSimple
          :link="share.default.link"
          :text="share.default.text"
          :list="['vk', 'fb', 'ok', 'tw']"
          :pixels="share.default.pixels"
        />
      </div>
    </template>

    <template v-if="levelId === 3 && secretFound">
      <h1>Вы прошли игру!</h1>
      <p>
        И даже разблокировали секретный трофей, победив короля Алланта всего за
        10 ходов. Чтобы получить заслуженную награду в профиле на Пикабу,
        введите свой ник в специальном поле ниже.
      </p>
      <Form />
      <img src="../assets/img/divider.svg" class="modal__divider" />
      <p>
        В мире PlayStation 5 будут ждать вашего возвращения: подробнее о
        консолях PS5 вы можете узнать
        <a :href="links.store | randomizeLink">в фирменном интернет-магазине</a
        >.
      </p>
      <div class="modal__actions">
        <a class="button" :href="links.preorder | randomizeLink" target="_blank"
          >Подробнее о PS5</a
        >
        <button
          class="button button--secondary"
          @click="restart"
          :data-pixel="pixels.restart"
        >
          Начать заново
        </button>
      </div>
      <img src="../assets/img/divider.svg" class="modal__divider" />
      <div class="finish-sharer">
        <SharerSimple
          :link="share.trophy.link"
          :text="share.trophy.text"
          :list="['vk', 'fb', 'ok', 'tw']"
          :pixels="share.trophy.pixels"
        />
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Modal from "./Modal";
import Form from "./Form";
import ModalShield from "./ModalShield";
import getRandomFact from "../helpers/getRandomFact";
import SharerSimple from "../classes/sharer/components/SharerSimple.vue";

export default {
  data() {
    return {
      pixels: {
        next:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhizn&pr=%random%&ptrc=b",
        levels: [
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdb&pr=%random%&ptrc=b",
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdg&pr=%random%&ptrc=b",
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjfm&pr=%random%&ptrc=b",
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdd&pr=%random%&ptrc=b"
        ],
        restart:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjct&pr=%random%&ptrc=b"
      },
      links: {
        preorder:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhjde&pr=%random%",
        store:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhjcs&pr=%random%"
      },
      share: {
        trophy: {
          link: "https://specials.pikabu.ru/ps5-game/api/share?t=1",
          text:
            "В мире PlayStation 5 меня теперь запомнят! Спросите меня, как получить секретный трофей!",
          pixels: {
            vk:
              "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdo&pr=%random%&ptrc=b",
            fb:
              "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdr&pr=%random%&ptrc=b",
            ok:
              "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdt&pr=%random%&ptrc=b",
            tw:
              "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdl&pr=%random%&ptrc=b"
          }
        },
        default: {
          link: "https://specials.pikabu.ru/ps5-game/api/share?t=0",
          text:
            "В мире PlayStation 5 меня теперь запомнят! Но получить секретный трофей мне так и не удалось.",
          pixels: {
            vk:
              "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdn&pr=%random%&ptrc=b",
            fb:
              "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdq&pr=%random%&ptrc=b",
            ok:
              "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdp&pr=%random%&ptrc=b",
            tw:
              "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjds&pr=%random%&ptrc=b"
          }
        }
      }
    };
  },
  components: { Modal, Form, ModalShield, SharerSimple },
  computed: {
    ...mapState(["levelId", "levels"]),
    ...mapGetters(["secretFound"])
  },
  methods: {
    getRandomFact,
    ...mapActions(["next", "restart"]),
    nextLevel() {
      this.$metrika.showPixel(this.pixels.levels[this.levelId - 1]);
      this.next();
    }
  },
  updated() {
    if (this.levels[this.levelId].state === "finish" && this.levelId == 3) {
      if (this.secretFound) {
        this.$metrika.showPixel(this.pixels.levels[3]);
      } else {
        this.$metrika.showPixel(this.pixels.levels[this.levelId - 1]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal__actions {
  .button {
    max-width: 225px;
  }
}
</style>

<style lang="scss">
.finish-sharer {
  .sharer-simple {
    .sharer__item {
      color: #379cd8;
      background-color: #ffffff;
      border: 1px solid #7bcbef;
      box-shadow: 0px 5px 0px -1px #ffffff, 0px 5px 0px #7bcbef;
      width: 45px;
      height: 45px;
      border-radius: 5px;
    }

    .sharer__icon svg {
      width: 60%;
      height: 100%;
    }
  }
}
</style>
